export default __webpack_public_path__ + "static/media/Binding of the Endless Sands.0074b759.jpg";